<template>
    <div class="vehicle">
        <div v-if="['e-bicycle'].includes(vehicle)" >
        
                <VehicleElectricConsumption
                :charge_distance_min=10
                :charge_distance_max=300
                :charge_capacity_min=.1
                :charge_capacity_max=1.1
                 v-on:charge_distance="electric_charge_distance = $event"
                 v-on:charge_capacity="electric_charge_capacity = $event"
                :defaults="{charge_capacity:electric_charge_capacity,charge_distance: electric_charge_distance}"
                />
                <hr class="half spacer" />

        </div>
        <div v-if="[ 'bicycle', 'e-bicycle'].includes(vehicle)" class="bg calculator">
            <h3>
            {{ $t('commute.title.other-monthly-cost', {vehicle: vehicle_label}) }} 
            </h3>
            
            
            <VehicleMaintenanceCosts
            :vehicle="vehicle"
            :init_data=maintenance_costs
            v-model="maintenance_costs" 
            :update="notify_parent()"
            />
            
            <p>
            {{ $t('commute.title.other-monthly-cost.note') }}
            </p>
             {{ convert('formatMoney','') }}
             
             <ConvertedNumber
            classes="money" 
            v-on:input="monthly_cost = $event"
            :default_value=monthly_cost
            :min=0 :max=3000
            :change="notify_parent()"

            />
             <span v-if="monthly_cost>0" >
              (={{ convert('formatMoney', parseInt(monthly_cost * 12)) }} {{ $t('per_year') }})
              </span>
              
              
                        
              <hr class="half spacer" />
        </div>
        <div v-if="['other'].includes(vehicle)"  class="bg calculator">
            <h3>
            {{ $t('commute.title.other-monthly-cost', {vehicle: vehicle_label}) }} 
            </h3>
            {{ convert('formatMoney','') }}
            
            <ConvertedNumber
            classes="money" 
            v-on:input="monthly_cost = $event"
            :default_value=monthly_cost
            :min=0 :max=3000
            :change="notify_parent()"

            />
            <span v-if="monthly_cost>0" >
              (={{ convert('formatMoney', parseInt(monthly_cost * 12)) }} {{ $t('per_year') }})
              </span>
            <hr class="half spacer" />
        </div>
        
        <div v-if="['public'].includes(vehicle)"  class="bg calculator">
            <h3>
            {{ $t('commute.title.public-monthly-cost') }} 
            </h3>
            {{ convert('formatMoney','') }}
            
            <ConvertedNumber
            classes="money" 
            v-on:input="monthly_cost = $event"
            :default_value=monthly_cost
            :min=0 :max=3000
            :change="notify_parent()"

            />
            
            <hr class="half spacer" />
        </div>
        

 
        <div v-if="['car', 'motorcycle'].includes(vehicle) "  class="bg calculator">
            
            <h3>
            {{ $t('commute.title.car-monthly-cost', {vehicle : vehicle_label}) }} 
            </h3>
            <p>
            {{ $t('commute.title.car-monthly-cost.note') }} 
            </p>
            <ul>
            <li> {{ convert('formatMoney', '') }}
            
            <ConvertedNumber
            :classes="'money ' + monthly_prompt" 
            v-on:input="monthly_loan = $event"
            :default_value=monthly_loan
            :min=0 :max=3000
            :change="notify_parent()"
            />
            
            <span :class="monthly_prompt" >
            {{ $t('commute.title.car-monthly_loan') }}
            </span>
            <span v-if="monthly_loan>0" >
            (={{ convert('formatMoney', parseInt(monthly_loan * 12)) }} {{ $t('per_year') }})
            </span>
            
            </li>
            <li> {{ convert('formatMoney', '') }}
            
            <ConvertedNumber
            :classes="'money ' + monthly_prompt" 
            v-on:input="monthly_insurance = $event"
            :default_value=monthly_insurance
            :min=0 :max=3000
            :change="notify_parent()"

            />
            <span :class="monthly_prompt" >
            {{ $t('commute.title.car-monthly_insurance') }}
            </span>
            <span v-if="monthly_insurance>0" >
            (={{ convert('formatMoney', parseInt(monthly_insurance * 12)) }} {{ $t('per_year') }})
            </span>
            
            </li>
            
            <li> {{ convert('formatMoney', '') }}
            
            <ConvertedNumber
            classes="money" 
            v-on:input="monthly_parking = $event"
            :default_value=monthly_parking
            :min=0 :max=3000
            :change="notify_parent()"
            />
            
             {{ $t('commute.title.car-monthly_parking') }}
             <span v-if="monthly_parking>0" >
            (={{ convert('formatMoney', parseInt(monthly_parking * 12)) }} {{ $t('per_year') }})
            </span>
             
             </li>
             
            </ul>
            
            <div>
            
        </div>

        <h3> {{ $t('commute.title.car-monthly_maintenance') }} </h3>
                       
           <VehicleMaintenanceCosts
           :vehicle="vehicle"
            :init_data=maintenance_costs
            v-model="maintenance_costs" 
            :update="notify_parent()"
            />
                        
        </div>
        
        <div v-if="['car', 'motorcycle'].includes(vehicle)   && answered_questions.includes('costs')" >
            <hr class="half spacer" />
            <h3>
            {{ $t('commute.title.fuel', {vehicle : vehicle_label}) }} 
    
            </h3>
            
            <RadioGroup
                v-model="energy_source"
                name="energy_source"
                :div_classes=bootstrap_div_classes
                :default_val="energy_source"
                :items=energy_sources />
        
            <div v-if="['car'].includes(vehicle)" >
                <small>
                    {{ $t('commute.title.fuel.note1') }} 
                </small>
            </div>
        
            <div v-if="['gas', 'diesel', 'hybrid'].includes(energy_source)">
                <hr class="half spacer" />

                <h3>
                    {{ $t('commute.title.fuelconsumption') }} 
    
                </h3>
                <div v-if="energy_source === 'lpg'" >
                    <small>
                    {{ $t('commute.title.fuelconsumption.lpgnote') }} 
                    </small>
                </div>
                
                <small id="fuel_consumptionHelp" class="form-text text-muted">
                    {{ $t('commute.title.fuelconsumption.note1') }} 
                    </small>
                <div class="form-group col-4">
                    <VehicleICConsumption
                    v-model=fuel_consumption
                    :min=min_fuel_consumption
                    :max=max_fuel_consumption
                    :default_val=fuel_consumption
                    distance_unit="km"
                    display_unit="lp100km"
                    :change="notify_parent()"
                    />
                </div>
            </div>
            <div v-if="energy_source === 'electric'">

                <VehicleElectricConsumption
                 v-on:charge_distance="electric_charge_distance = $event"
                 v-on:charge_capacity="electric_charge_capacity = $event"
                :defaults="{charge_capacity:electric_charge_capacity,charge_distance: electric_charge_distance}"
                />
            </div>
            

        </div>
        
    </div>    
</template>

<script>
    import RadioGroup from './RadioGroup.vue'
    import SelectList from './SelectList.vue'
    import VehicleMaintenanceCosts from './VehicleMaintenanceCosts.vue'
    import VehicleICConsumption from './VehicleICConsumption.vue'
    import VehicleElectricConsumption from './VehicleElectricConsumption.vue'
    import ConvertedNumber from './ConvertedNumber.vue'

    import Vehicles from '../mixins/Vehicles.js'
    import Persistent from '../mixins/Persistent.js'

    import settings from '../settings.js'
    import conversions from '../conversions.js'

    export default {
        mixins: [Vehicles, Persistent],
        components: {
            RadioGroup,SelectList,
            VehicleICConsumption,
            VehicleElectricConsumption,
            VehicleMaintenanceCosts,
            ConvertedNumber
        },
        props: {
            other_vehicle : "",
            vehicle : "",        
        },
        data: function(){
            return {
                monthly_cost: 0,
                monthly_loan: 0,
                monthly_insurance: 0,
                maintenance_costs: {},
                monthly_parking: 0,
                energy_source: "",
                fuel_consumption: 0,
                electric_charge_capacity: "",
                electric_charge_distance: "",
                movement_type: "",
                speed_ceiling: 0,
                speed_floor: 0,
                data_complete: false
            }
        },
        watch : {
            other_vehicle : function(){
                for(var v in this.other_vehicles){
                    if (this.other_vehicles[v].value === this.other_vehicle){
                        this.speed_ceiling = this.other_vehicles[v].speed_ceiling ? this.other_vehicles[v].speed_ceiling : 25;
                        this.speed_floor = this.other_vehicles[v].speed_floor ? this.other_vehicles[v].speed_floor : 5;
                        if(this.other_vehicle == "walk"){
                            this.movement_type = "walking"
                        } else {
                            this.movement_type = "bicycling"    
                        }
                    }
                }
            },
            vehicle : function(){
                this.set_limits()
            }
        },
        computed : {
            bootstrap_div_classes : () => {
                return "dbtn-group dbtn-group-toggle capitalize"
            },
            monthly_prompt : function(){
                if(this.answered_questions.includes('costs')){
                    return ""
                }
                
                return "red"
            },
            answered_questions: function(){
                let aq = []
                
                if (['car', 'motorcycle'].includes(this.vehicle)){
                    if((this.monthly_loan + this.monthly_insurance) > 0){
                        aq.push('costs') 
                    }
                }
                
                if(['car', 'motorcycle'].includes(this.vehicle)){
                    if(this.energy_source != ""){
                        aq.push('energy_source')
                    }                
                } else {
                    aq.push('energy_source')
                }
                return aq            
            },
            vehicle_label : function(){
                let k = 'vehicles.'+this.vehicle
                if(this.vehicle == 'other'){
                    k = 'other_vehicles.'+this.other_vehicle
                }
    
                return this.$t(k)
            },
            
        },
        mounted : function(){
            this.set_limits()
        },
        methods: {
            set_limits: function(){
                if(this.vehicle != 'other'){
                    for(var v in this.vehicles){
                        if (this.vehicles[v].value === this.vehicle){
                            this.movement_type = this.vehicles[v]['movement_type']
                            this.speed_ceiling = this.vehicles[v].speed_ceiling;
                            this.speed_floor = this.vehicles[v].speed_floor ? this.vehicles[v].speed_floor : 0;
                            try {
                                if(this.electric_charge_capacity == ""){
                                    this.electric_charge_capacity = this.vehicles[v].electric_charge_capacity
                                    this.electric_charge_distance = this.vehicles[v].electric_charge_distance
                                } else {
                                    //console.log(this.vehicles[v].charge_capacity_min)
                                    //console.log(this.electric_charge_capacity)
                                    //console.log(this.vehicles[v].charge_capacity_max)
                                    if(!(this.vehicles[v].charge_capacity_min < this.electric_charge_capacity && this.electric_charge_capacity < this.vehicles[v].charge_capacity_max )) {
                                        //console.log("setting this.electric_charge_capacity to "+this.vehicles[v].electric_charge_capacity)
                                        this.electric_charge_capacity = this.vehicles[v].electric_charge_capacity
                                    }
                                    if(!(this.vehicles[v].charge_distance_min < this.electric_charge_distance && this.electric_charge_distance < this.vehicles[v].charge_distance_max )) {
                                        this.electric_charge_distance = this.vehicles[v].electric_charge_distance
                                    }
                                }
                            } catch(err){}
                            try {
                                if(!(this.fuel_consumption > 0)){
                                    this.fuel_consumption = this.vehicles[v].fuel_consumption
                                }
                            } catch(err){}
                            break;
                        }
                    }
                }
            },
            mario : function(){
                if (this.other_vehicle === 'unicorn'){
                    window.setTimeout(function(){
                        window.open("https://youtu.be/u_1xq5bQkMw?t=9", "_blank");
                    }, 200);
                    this.other_vehicle = "" // to avoid infinite loop
                }
            },
            notify_parent : function(){
                
                this.data_complete = false

                if (['car', 'motorcycle'].includes(this.vehicle)){
                    if(this.answered_questions.includes('costs') && this.answered_questions.includes('energy_source')){
                        this.data_complete = true
                    }
                } else if(this.vehicle != ""){
                    this.data_complete = true
                }

                this.mario()
                
                this.save_data()
            },
            convert : function(fn, ...arg){
                return conversions[fn](...arg);
            }
        }
    }
    

</script>

<style>
</style>